import PropTypes from 'prop-types';
// Utils
import { cn } from '@repo/zolintra-utils';
// Components
import { Icon } from '../../atoms/Icon/Icon';
// Styles
import styles from './DubbleSideButton.module.css';

export function DubbleSideButton({
  onLeftClick, onRightClick, label, size, className,
}) {
  return (
    <div className={cn([styles.button, styles[size], className])}>
      <button type="button" aria-label="previous" className={styles['left-button']} onClick={onLeftClick}>
        <Icon icon="arrowDown" />
      </button>
      <span className={styles.label}>{label}</span>
      <button type="button" aria-label="next" className={styles['right-button']} onClick={onRightClick}>
        <Icon icon="arrowDown" />
      </button>
    </div>
  );
}

DubbleSideButton.propTypes = {
  onLeftClick: PropTypes.func.isRequired,
  onRightClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium']),
  className: PropTypes.string,
};

DubbleSideButton.defaultProps = {
  size: 'medium',
  className: '',
};

export default DubbleSideButton;
